"use strict";

class PropertyUrlController {

    constructor($window, SSHttpService, SSUtilService, SSAlertService, OTPService, SSConfigService, SSUserService) {
        const self = this;

        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        // Property Status
        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT; // Just Created
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW; // Submitted for Review
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED; // Rejected by the Showsuite Admin
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED; // Listed on portal and publicly visible

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.getProperty();
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.propertyParams = angular.copy(self.property);
        });
    }

    editPropertyNamedId(status) {
        const self = this;

        self.namedIdEditMode = status;

        if (!self.namedIdEditMode) {
            self.propertyParams.named_id = self.property.named_id;
        }
    }

    updatePropertyNamedId() {
        const self = this;

        // Validate
        if (!self.SSUtilService.isNamedIdValid(self.propertyParams.named_id)) {
            self.propertyErrors.named_id = 'Invalid Id';
            return;
        }
        self.propertyParams.named_id = self.propertyParams.named_id.trim();

        // Is Changed
        if (self.propertyParams.named_id == self.property.named_id) {
            self.editPropertyNamedId(false);
            return;
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/properties/' + self.property.id + '/update-named-id';
            let params = {
                named_id: self.propertyParams.named_id
            };
            self.propertyErrors = {};

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    self.propertyErrors = self.SSHttpService.parseErrors(response);
                    return;
                }

                self.SSAlertService.success('Success!', 'Project URL updated successfully.');

                self.property.named_id = self.propertyParams.named_id;
                self.editPropertyNamedId(false);
            });
        });
    }

}

PropertyUrlController.$inject = ['$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'OTPService', 'SSConfigService', 'SSUserService'];
app.controller('PropertyUrlController', PropertyUrlController);

